/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../../../_metronic/layout/core'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import UserService from '../../../../../services/user'
import JobService from '../../../../../services/job'
import CompanyService from '../../../../../services/company'
import useServices from '../../../../../utils/hooks/useServices'
import {Link} from 'react-router-dom'

const heads = [
  {
    name: '',
    label: 'Judul',
  },
  {
    name: '',
    label: 'Tanggal Melamar',
  },
  {
    name: '',
    label: 'Status',
  },
  {
    name: '',
    label: 'Total Pelamar',
  },
]

const status = [
  {
    name: 'Menunggu Verifikasi',
  },
  {
    name: 'Aktif',
  },
  {
    name: 'Ditolak',
  },
  {
    name: 'Non-Aktif',
  },
]

const StatusComponent = (statusNumber: any) => {
  let theme = ''
  if (statusNumber == 0) {
    theme = 'success'
  } else if (statusNumber == 1) {
    theme = 'success'
  } else if (statusNumber == 2) {
    theme = 'danger'
  } else {
    theme = 'dark'
  }
  return (
    <Button className={`shadow-none btn btn-sm btn-outline btn-outline-${theme}`} variant='outline'>
      {status[statusNumber].name}
    </Button>
  )
}

const DashboardPage: FC = () => {
  const [card] = useServices(UserService.dashboardCompany)
  const [jobApply] = useServices(JobService.jobApplyHash, {
    per_page: 5,
    sort_field: 'created_at',
    sort_order: 'desc',
  })
  const [applicant] = useServices(CompanyService.applicantByCompany, {
    per_page: 5,
    sort_field: 'created_at',
    sort_order: 'desc',
  })

  return (
    <>
      <div className='row'>
        <div className='col-md-4'>
          <div className='card-custom'>
            <h6 className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2 mb-4'>
              {card?.data?.alumni_registered ?? 0}
            </h6>
            <span className='text-gray-400 pt-1 fw-semibold fs-6'>Total Alumni Aktif</span>
          </div>
        </div>
        <div className='col-md-4'>
          <div className='card-custom'>
            <h6 className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2 mb-4'>
              {card?.data?.my_company_jobs ?? 0}
            </h6>
            <span className='text-gray-400 pt-1 fw-semibold fs-6'>Total Lowongan Aktif</span>
          </div>
        </div>
        <div className='col-md-4'>
          <div className='card-custom'>
            <h6 className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2 mb-4'>
              {card?.data?.total_applicants ?? 0}
            </h6>
            <span className='text-gray-400 pt-1 fw-semibold fs-6'>Total Pelamar</span>
          </div>
        </div>
      </div>
      <br />
      <div className='row'>
        <div className='col-md-12'>
          <div className='card-custom'>
            <div className='row'>
              <div className='col-md-6'>
                <h6>Lowongan Terbaru</h6>
              </div>
              {/* <div className='col-md-6 text-end'>
                <Link to={'/list-job'} className='link-primary'>
                  Lihat Semua
                </Link>
              </div> */}
            </div>

            <span>Status terbaru Lowongan yang saya ajukan</span>
            <Table responsive='sm mt-4'>
              <thead>
                <tr>
                  <th>#</th>
                  {heads.map((item, index) => (
                    <th key={index}>{item.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {jobApply?.data?.data.map((item: any, key: any) => {
                  return (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>{item?.company_job?.company_jobs_title}</td>
                      <td>{new Date(item?.created_at).toLocaleString()}</td>
                      <td>{StatusComponent(parseInt(item?.company_job?.company_jobs_status))}</td>
                      <td style={{textAlign: 'left'}}>{item?.company_job?.total_applicants}</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </div>
        </div>
        <div className='col-md-12 mt-8'>
          <div className='card-custom'>
            <div className='row'>
              <div className='col-md-6'>
                <h6>Pelamar Terbaru</h6>
              </div>
              {/* <div className='col-md-6 text-end'>
                <Link to={'/list-job'} className='link-primary'>
                  Lihat Semua
                </Link>
              </div> */}
            </div>

            <span>Pelamar terbaru lowongan pekerjaan yang saya ajukan</span>
            <Table responsive='sm mt-4'>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Kandidat</th>
                  <th>Lowongan</th>
                </tr>
              </thead>
              <tbody>
                {applicant?.data?.data.map((item: any, key: any) => {
                  return (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>{item?.user?.fullname}</td>
                      <td>{item?.company_job?.company_jobs_title}</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </>
  )
}

const Dashboard: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Dashboard
      </PageTitle>
      <DashboardPage />
    </>
  )
}

export default Dashboard
